(() => {
  if (!customElements.get('main-collection-inner')) {
    customElements.define(
      'main-collection-inner',
      class CollectionHeader extends HTMLElement {
        constructor() {
          super();
          this.init();
        };

        cookie(name) {
          let value = `; ${document.cookie}`;
          let parts = value.split(`; ${name}=`);
          if (parts.length === 2) return decodeURIComponent(parts.pop().split(';').shift());
          return null;
        };

        /* Set days to '' for session cookies */
        setCookie(name, value, days) {
          let d = new Date;
          d.setTime(d.getTime() + 24*60*60*1000*days);
          d = days != '' ? d.toGMTString() : '';
          document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + ";path=/;expires=" + d;
        };

        createStickyHeader() {
          const mainContent = document.getElementById('main');
          const shopifyHeader = document.getElementById('shopify-section-header');
          const stickyElements = document.querySelectorAll('.sticky--desktop');

          if (mainContent && shopifyHeader) {
            if (mainContent.hasAttribute('data-sticky-header')) {
              let banners = document.getElementById('shopify-section-collection-banners');
              let mobileNav = document.querySelector('.mobile-scroll-nav');

              if (banners) {
                banners.classList.add('sticky--mobile');
                banners.style.top = `${shopifyHeader.offsetHeight}px`;
              }

              if (mobileNav) {
                mobileNav.classList.add('sticky--mobile');
                mobileNav.style.top = `${shopifyHeader.offsetHeight + banners.offsetHeight - 1}px`;
              }
            }
          }

          if (stickyElements.length > 0) {
            stickyElements.forEach((el) => {
              el.style.cssText = `top: ${shopifyHeader.offsetHeight}px !important;`;
            })
          }
        };

        init() {
          /* this.createStickyHeader(); */
          this.gridLayout();
          /*
          this.timer = false;

          window.addEventListener('resize', () => {
            if (this.timer) {
              clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
              this.createStickyHeader();
            }, 100);
          });
          */
        };

        gridLayout() {
          const gridClasses = [
            'collection-grid-layout--lg',
            'collection-grid-layout--default'
          ];

          const toggles = document.querySelectorAll('[data-collection-grid]');

          // remember preference
          const preference = this.cookie('collection-grid-preference');

          if (preference) {
            document.body.classList.add(`collection-grid-layout--${preference}`);
            toggles.forEach((el) => el.classList.remove('active'));
            const activeToggles = document.querySelectorAll(`[data-collection-grid="${preference}"]`);
            activeToggles.forEach((el) => el.classList.add('active'));
          }

          toggles.forEach((tgl) => {
            tgl.addEventListener('click', (e) => {
              e.preventDefault();
              const columnSize = tgl.dataset.collectionGrid;
              const carousels = document.querySelectorAll('[data-product-tile-carousel]');
              document.body.classList.remove(...gridClasses);
              document.body.classList.add(`collection-grid-layout--${columnSize}`);
              toggles.forEach((el) => el.classList.remove('active'));
              this.setCookie('collection-grid-preference', `${columnSize}`, '');

              const activeToggles = document.querySelectorAll(`[data-collection-grid="${columnSize}"]`);
              activeToggles.forEach((el) => el.classList.add('active'));

              if (carousels.length) {
                for (const tile in window.collectionSwipers) {
                  window.collectionSwipers[tile].update();
                }
              }

              window.dispatchEvent(new Event('resize'));
            });
          });
        };
      }
    )
  }
})();